import { Box } from "@material-ui/core";
import BuyingEmailsForUser from '../../adminToolsTabs/components/accounts/BuyingEmailsForUser';
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../features/auth/authSlice";

const BuyingEmailsHome = () => {
  const user= useSelector(selectCurrentUser);

  let LoadingIcon = () => <Box style={{ marginTop: "7em" }}>
    <CircularProgress size={50} />
  </Box>

  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
      {
        (user == null) ?
          <LoadingIcon />
          :
          <Box style={{ 'height': '600px', width: "100%" }}>
            <h3 style={{ width: '100%', margin: ' 0 0 0 0', color: 'var(--orange)' }}>Buying Email Logins</h3>
            <BuyingEmailsForUser userId={user.id} isBeeViewing={true} />
          </Box>
      }
    </Box>
  );
}
export default BuyingEmailsHome;